import React from 'react'
import StepManager from '../components/stepManager';
import { Redirect } from 'react-router-dom';
import { UiGetCustomer, documentation as UiGetCustomerDoc } from "./uiGetCustomer";
import {UiDashboard, documentation as UiDashboardDoc} from "./uiDashboard";

let documentation = {
    title: "New Acuadori dashboard",
    subtitle: 'Adds a new dashboard to Thingsboard Acuadori',
    brief: <p>Adds a new dashboard to Thingsboard and links it to the chosen Customer</p>,
    content: <p>Adds a new dashboard to Thingsboard, and links it to the chosen Customer. 
        Each Customer user-types can view the Acuadori fields and devices it owns.
    </p>,

    steps: [
        { id: 0, ...UiGetCustomerDoc },
        { id: 1, ...UiDashboardDoc },
    ]
};

class UiGenerateDashboard extends React.Component {

    static defaultProps = {};
    constructor(props) {
        super(props);
        this.stepManagerRef = React.createRef();
        this.state = {
            finished: false,
            nextRoute: this.props.nextRoute,

            customers: { name: '', instances: [] },
            field: { data: null, report: null },
        };
    }

    documentation = () => documentation;

    stepManagerAdvance = () => {
        const element = this.stepManagerRef.current;
        element.advance();
    };

    renderGetCustomerForm = () => {
        return (
            <UiGetCustomer
                error={this.handleSubmitError}
                services={{ customer: this.props.services.customer }}
                finished={(report) => {
                    this.setState({ customers: report });
                    this.stepManagerAdvance();
                }
                } />
        );
    };

    renderDashboard = () => {
        return (
            <UiDashboard
                services={this.props.services.dashboard}
                customers={this.state.customers}
                finished={(data) => {
                    this.setState({ dashboards: data });
                    this.stepManagerAdvance();
                }} />
        );
    };

    render() {
        let documentation = this.documentation();
        let steps = documentation.steps;
        return (
            <div>
                <div className="container-fluid">
                    {this.state.finished && <Redirect to={this.props.nextRoute} />}
                    <StepManager ref={this.stepManagerRef}
                        startStepId={0} endStepId={1}
                        onFinished={() => {
                            window.open(this.props.links.thingsboardRoutes.Dashboard, '_blank');
                            this.setState({ finished: true })
                        }}
                        documentation= {documentation}
                        stepList={[
                            { stepId: 0, stepName: steps[0].title, formValue: this.renderGetCustomerForm, documentation: steps[0] },
                            { stepId: 1, stepName: steps[1].title, formValue: this.renderDashboard , documentation: steps[1]},
                        ]} />
                </div>
            </div>);
    }
}


export default UiGenerateDashboard;
export {UiGenerateDashboard, documentation}